import { createSlice } from "@reduxjs/toolkit";
import product from "../../client/components/cms/products/product";
import { getCmsProductListDialer, postCmsProductDialer } from "../repositories/tools/PushDialer";

const DialerSlice = createSlice({
    name: "DialerReducer",
    initialState: {

        //GET INITIAL STATE 

        productDialerLoading: false, 
        productDialerData: null, 
        productDialerError: null , 

        //POST INITIAL STATE 
        postDialerLoading: false, 
        postDialerData: null, 
        postDialerError: null, 

        //FILTER TITLE INITIAL STATE
        productTitleLoading: false, 
        productTitleData: null,
        productTitleError: null,
       

    },
    reducers : 
    {
        getProductDialerLoading(state, action) {
            return {
                ...state,
                productDialerLoading: true,
            };
        },

        getProductDialerSuccess(state , action){
            return {
                ...state, 
                productDialerLoading: false, 
                productDialerData : action.payload,
            }
        },

        getProductDialerFailure(state, action){
            return {
                ...state,
                productDialerLoading: false,
                productDialerError: action.payload,
            };

        }, 

        postProductDialerLoading(state , action){
            return{
                ...state, 
                postDialerLoading: true,
            };
        }, 

        postProductDialerSuccess(state , action){
            return{
                ...state, 
                postDialerLoading: false,
                postDialerData: action.payload,
            };
        }, 

        postProductDialerFailure(state , action){
            return{
                ...state,
                postDialerLoading: false,
                postDialerError: action.payload,
            };
        },

        getProductTitleLoading(state, action){
            return{
                ...state,
                productTitleLoading: true,
            }
        },

        getProductTitleSuccess(state , action){
            return{
                ...state,
                productTitleLoading: false,
                productTitleData: action.payload,
            }
        },

        getProductTitleFailure(state, action){
            return{
                ...state,
                productTitleLoading: false,
                productTitleError: action.payload,
            }
        },
    }
}); 
export const {
    getProductDialerLoading,
    getProductDialerSuccess,
    getProductDialerFailure,
    postProductDialerLoading,
    postProductDialerSuccess,
    postProductDialerFailure,
    getProductTitleLoading,
    getProductTitleSuccess,
    getProductTitleFailure,
} = DialerSlice.actions;

export const getProductDialer = (params) => {
    return async (dispatch) => {
        dispatch(getProductTitleLoading());
        await getCmsProductListDialer(params)
            .then((response) => {
                if (response?.status >= 200 && response?.status <= 300) {
                    dispatch(getProductDialerSuccess(response?.data?.data));
                }
            })
            .catch((error) => {
                if (error && error.response) {
                    dispatch(getProductDialerFailure(error.message));
                }
            });
    };
};

export const postProductDialer = (params) => {
    return async (dispatch) => {
        dispatch(postProductDialerLoading());
        await postCmsProductDialer(params)
            .then((response) => {
                if (response?.status >= 200 && response?.status <= 300) {
                    dispatch(postProductDialerSuccess(response?.data?.data));
                }
            })
            .catch((error) => {
                if (error && error.response) {
                    dispatch(postProductDialerFailure(error.message));
                }
            });
    };
};

export const getproductTitle = (params) => {
    return async (dispatch) => {
        dispatch(getProductTitleLoading()); 
        await getCmsProductListDialer(params)
            .then((response) => {
                if (response?.status >= 200 && response?.status <= 300) {
                    dispatch(getProductTitleSuccess(response?.data?.data));
                }
            })
            .catch((error) => {
                if (error && error.response) {
                    dispatch(getProductTitleFailure(error.message));
                }
            });
    };
}

export default DialerSlice.reducer;